import { ConfirmMessageContentProps } from './confirm-message-content.types';

export const ConfirmMessageContentPreset: Partial<ConfirmMessageContentProps> = {
  message: 'Los datos ingresados en la solicitud se perderán.',
  onClose: () => {},
  onConfirm: () => {},
  show: false,
};
